import { ThemeType } from '@share/enums';
import { hasThemeSwitcher } from '@asset/themes/config';
import { user } from '@state/user';
import ImgMoon from '@img/icon/moon.webp';
import ImgSun from '@img/icon/sun.webp';

function ThemeSwitcher() {
  const clickedClass = 'clicked';
  const { body } = document;
  const { theme, setTheme } = user.useContainer();

  if (theme === ThemeType.LIGHT || theme === ThemeType.DARK) {
    body.classList.add(theme);
  } else {
    body.classList.add(ThemeType.DARK);
  }

  const switchTheme = (e: any) => {
    if (theme === ThemeType.DARK) {
      body.classList.replace(ThemeType.DARK, ThemeType.LIGHT);
      e.target.classList.remove(clickedClass);
      setTheme(ThemeType.LIGHT);
    } else {
      body.classList.replace(ThemeType.LIGHT, ThemeType.DARK);
      e.target.classList.add(clickedClass);
      setTheme(ThemeType.DARK);
    }
  };

  return hasThemeSwitcher ? (
    <div className="mode_switcher">
      <button type="button" onClick={(e) => switchTheme(e)}>
        <img
          alt="Theme Switcher"
          height="18"
          loading="lazy"
          src={theme === ThemeType.DARK ? ImgSun : ImgMoon}
          width="18"
        />
      </button>
    </div>
  ) : (
    <div />
  );
}

export default ThemeSwitcher;
